import styled from "styled-components";
import { fonts } from "../../styles/fonts";

const PageTitle = styled.h1`
  font-family: ${fonts.apropal};
  font-weight: 600;
  font-size: 3rem;
  margin-bottom: 20px;
`;

export default PageTitle;
